import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../keys';
export const bookingApi = createApi({
      reducerPath: "bookingApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
 reschedule: builder.mutation({
  query: (body) => ({
    url: "client/reschedule-slot/",
    method: "POST",
    body,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("livtoken"),
    },
  }),
}),
       getRefundHistory: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `client/get-payment-refunds/?page=${page}&limit=${limit}`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("livtoken"),
        },
      }),
    }),
    deleteAccount:builder.mutation({
      query:(body)=>({
        url:"client/account-deletion-request/",
        method:"POST",
         body,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("livtoken"),
    },
      })
    })
  })
})
export const {
useRescheduleMutation,useGetRefundHistoryQuery,useDeleteAccountMutation} = bookingApi;